import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppConstants } from 'src/app/app-constants';
import { AppConfigService } from 'src/app/config/appconfig.service';
import { UserDetails } from 'src/app/models/user-details.model';
import { PayloadService } from 'src/app/services/payload.service';
import { StorageService } from 'src/app/services/storage.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-payment-method',
  templateUrl: './payment-method.component.html',
  styleUrls: ['./payment-method.component.scss']
})
export class PaymentMethodComponent implements OnInit {

  showButton = true;
  showCancelButton = true;
  sendDataInterval;
  clientId = environment.quickPayClientId;
  accessToken = '';
  hideCVV = false;
  plaid = true;
  acceptableGiactWarnStatuses: string[] = ['ND00', 'RT03', 'GN01'];
  sendAcceptableWarncodes = false;
  waysToPay: URL = new URL(environment.quickPayUrl);

  paymentMethods = {  paymentMethodsListObject: [] };
  hideLayout: boolean = false;

  billPayIframe;
  userInfo: UserDetails;
  paymentAmount: number;
  isGracePayment = false;

  constructor(private router: Router, private payloadService: PayloadService, private storageService:StorageService,private config: AppConfigService) { 
    this.isGracePayment = this.config.getIsGracePayment();
    let userInfo = this.storageService.getUserInfo();
    if(userInfo == null){
       this.router.navigateByUrl('/policy-search');
    } else {
      this.userInfo = userInfo;
    }

    let paymentAmount = this.storageService.getPaymentAmount();
    if(paymentAmount == null){
       this.router.navigateByUrl('/payment');
    } else{
      this.paymentAmount = paymentAmount;
    }
  }

  ngOnInit(): void {
    this.setPayloadForPaymentMethod();
  }

  setPayloadForPaymentMethod(): void {
    const hideCVV = this.hideCVV;
    const plaid = this.plaid;
    const acceptableGiactWarnStatuses = this.acceptableGiactWarnStatuses;
    const accessToken = this.storageService.getAccessToken();
    if(!accessToken){
      this.router.navigateByUrl('/policy-search');
      return;
    }

    this.paymentMethods.paymentMethodsListObject = (!this.userInfo.allowBankCards || this.paymentAmount > AppConstants.CARD_LIMIT) ? 
        AppConstants.ONLY_EFT_ALLOWED : AppConstants.ALL_PAYMENT_METHODS;

    const paymentMethod = this.paymentMethods;

    const allowedCardTypes = this.userInfo.allowCreditCards? AppConstants.ALL_CARD_TYPES: AppConstants.ONLY_DEBIT_CARD_ALLOWED;

    this.payloadService.nationwideChoosePaymentMethodPayload = {
      details: {
        clientID: this.clientId,
        customerAccessToken: accessToken,
        lineOfBusiness: 'LIFE',
        paymentMethod,
        hideCVV,
        plaid,
        acceptableGiactWarnStatuses,
        consumerId: 'LifePaymentsPortal',
        allowedCardTypes,
      },
      messageId: 'choose-payment-method',
      inline: '',
      nationwideEnvironment: environment.env
    };
    console.log(this.payloadService.nationwideChoosePaymentMethodPayload);
    this.displayPaymentIframe();
  }
  displayPaymentIframe(): void {
    this.setupIframeWindow();
    const nationwideSiteWindow = window.open(
      this.waysToPay.href,
      'nationwide-iframe'
    );
    this.sendDataInterval = setTimeout(() => {
      nationwideSiteWindow.postMessage(this.payloadService.nationwideChoosePaymentMethodPayload, this.waysToPay.href);
    }, 5000);
    this.showButton = false;
  }

  setupIframeWindow(): void {
    window.addEventListener("message", this.onEvent.bind(this), false);
    this.billPayIframe = document.createElement('iframe');
    // eslint-disable-next-line max-len
    this.billPayIframe.setAttribute(
      'sandbox',
      'allow-modals allow-same-origin allow-scripts allow-forms allow-top-navigation allow-popups'
    );
    this.billPayIframe.setAttribute('allowtransparency', 'true');
    this.billPayIframe.setAttribute('aria-label', 'ways to pay iframe');
    this.billPayIframe.setAttribute('title', 'ways to pay iframe');
    // eslint-disable-next-line max-len
    this.billPayIframe.setAttribute(
      'style',
      'border: none !important; height:100%; width: 100%; min-height:275px;'
    );
    this.billPayIframe.name = 'nationwide-iframe';
    this.billPayIframe.id = 'nationwide-iframe';
    const nationwideDiv = document.getElementById('ways2pay-iframe');
    nationwideDiv.insertBefore(
      this.billPayIframe,
      nationwideDiv.firstElementChild.nextSibling
    );
  }

  onEvent(message) {
    if (message.origin == this.waysToPay.origin && message.data) {
      if (message.data.messageId) {
        if (message.data.messageId == "payment-type") {
          this.hideLayout = true;
          window.scrollTo(0, 0);
        } else if (message.data.messageId == "Previous") {
          this.hideLayout = false;
          window.scrollTo(0, 0);
        } else if (message.data.messageId == "payment-method") {
          window.scrollTo(0, 0);
          if (message.data.details) {
            let payment = message.data.details;
            if (payment.LIFE) {
              this.onNext(payment.LIFE)
            }
          }
          this.hideLayout = false;
        }
        console.log(message);
      } else if (message.data && message.data[0] && message.data[0] == "setHeight" && message.data[1])
        this.billPayIframe.style.height = message.data[1] + "px";
    }

  }



  onNext(payment:any) {
    setTimeout(()=>{
      if (payment) {
        this.storageService.setSelectedPaymentMethod(payment);
        this.router.navigateByUrl('/review');
      }
    },2000)
   
  }

  onBack() {
    this.router.navigateByUrl('/payment');
  }

  onCancel() {
    if (this.isGracePayment) {
      this.router.navigate(['/policy-search'], { fragment: 'grace-payment' });
    } else {
    window.location.href = 'https://www.nationwide.com/personal/member-services/pay-bill?utm_campaign=pl-sitelink&utm_medium=Search&utm_source=Bing&utm_content=All:PL:REP:NA:NA&utm_term=www%20nation&&msclkid=74591eadb69016dcc7837bfa31491e5d&gclid=74591eadb69016dcc7837bfa31491e5d&gclsrc=3p.ds';
    }
  }

}
